<ng-template #content>
    <div class="pretty-easy-image-link__header">
        <span class="pretty-easy-image-link__label">
            {{ label() | translate }}
        </span>
        @if (icon()) {
            <mat-icon class="pretty-easy-image-link__icon"
                    [svgIcon]="icon()">
            </mat-icon>
        }
    </div>
    @if(src()) {
        <img class="pretty-easy-image-link__image"
            [src]="src()"
            [alt]="(alt() ?? label()) | translate">
    }
</ng-template>

@if (link()) {
    @if (routerLink()) {
        <!-- Use routerLink if provided -->
        <a class="pretty-easy-image-link__anchor"
            [ngClass]="formattedClasses()"
            [routerLink]="routerLink()"
            routerLinkActive="pretty-easy-image-link__anchor--active"
            #rla="routerLinkActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [queryParams]="queryParams()"
            [fragment]="fragment()"
            [attr.data-label]="label()"
            [matTooltip]="isSidebarFolded ? (label() | translate) : null"
            [matTooltipPosition]="isSidebarFolded ? 'right' : null">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </a>
    } @else {
        <a class="pretty-easy-image-link__anchor"
            [ngClass]="formattedClasses()"
            [href]="href()"
            [attr.data-label]="label()"
            [matTooltip]="isSidebarFolded ? (label() | translate) : null"
            [matTooltipPosition]="isSidebarFolded ? 'right' : null">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </a>
    }
} @else if (action()) {
    <button class="pretty-easy-image-link__button"
            [ngClass]="formattedClasses()"
            data-e2e="pretty-easy-image-link-trigger-action"
            [attr.data-label]="label()"
            [matTooltip]="isSidebarFolded ? (label() | translate) : null"
            [matTooltipPosition]="isSidebarFolded ? 'right' : null"
            (click)="onClick($event)">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
}
